/**
 * App download links
 *
 * Shows only the app-store badge relevant to the visitor's OS inside every
 * `.app-download-links` container. Safe to call repeatedly.
 */
export function appDownloadLinks() {
    const $links = $('.app-download-links');
    if (!$links.length) return;

    const $appleStore = $links.find('.apple-store');
    const $googlePlay = $links.find('.google-play');

    if (!$appleStore.length || !$googlePlay.length) return;

    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const platform = navigator.platform || '';
    const isIPadOS  = platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    const isIOS     = (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) || isIPadOS;
    const isAndroid = /android/i.test(ua);
    const isMac     = /mac/i.test(platform);
    const isWindows = /win/i.test(platform);
    const isLinux   = /linux/i.test(platform);

    // Reset visibility before applying the OS-specific rule.
    $appleStore.add($googlePlay).css('display', '');

    if (isIOS) {
        $googlePlay.hide();
    } else if (isAndroid) {
        $appleStore.hide();
    } else if (isMac) {
        // Desktop macOS users should get the App Store badge.
        $googlePlay.hide();
    } else if (isWindows || isLinux) {
        // Desktop non-Apple users should get the Google Play badge.
        $appleStore.hide();
    }
}
